var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2374_21017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 16.5C10.6668 15.9477 11.1145 15.5 11.6668 15.5H17.5001C18.0524 15.5 18.5001 15.9477 18.5001 16.5C18.5001 17.0523 18.0524 17.5 17.5001 17.5H11.6668C11.1145 17.5 10.6668 17.0523 10.6668 16.5Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50004 16.5C1.50004 15.9477 1.94776 15.5 2.50004 15.5H8.33337C8.88566 15.5 9.33337 15.9477 9.33337 16.5C9.33337 17.0523 8.88566 17.5 8.33337 17.5H2.50004C1.94776 17.5 1.50004 17.0523 1.50004 16.5Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10C9 9.44776 9.44772 9.00004 10 9.00004H17.5C18.0523 9.00004 18.5 9.44776 18.5 10C18.5 10.5523 18.0523 11 17.5 11H10C9.44772 11 9 10.5523 9 10Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 10C1.5 9.44776 1.94772 9.00004 2.5 9.00004H6.66667C7.21895 9.00004 7.66667 9.44776 7.66667 10C7.66667 10.5523 7.21895 11 6.66667 11H2.5C1.94772 11 1.5 10.5523 1.5 10Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 3.5C12.3333 2.94772 12.781 2.5 13.3333 2.5L17.5 2.5C18.0522 2.5 18.5 2.94772 18.5 3.5C18.5 4.05228 18.0522 4.5 17.5 4.5H13.3333C12.781 4.5 12.3333 4.05228 12.3333 3.5Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50004 3.5C1.50004 2.94772 1.94776 2.5 2.50004 2.5L10 2.5C10.5523 2.5 11 2.94771 11 3.5C11 4.05228 10.5523 4.5 10 4.5L2.50004 4.5C1.94776 4.5 1.50004 4.05228 1.50004 3.5Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6668 20C11.1145 20 10.6668 19.5523 10.6668 19V14C10.6668 13.4477 11.1145 13 11.6668 13C12.2191 13 12.6668 13.4477 12.6668 14V19C12.6668 19.5523 12.2191 20 11.6668 20Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 13.5C6.11446 13.5 5.66675 13.0523 5.66675 12.5V7.50004C5.66675 6.94776 6.11446 6.50004 6.66675 6.50004C7.21903 6.50004 7.66675 6.94776 7.66675 7.50004V12.5C7.66675 13.0523 7.21903 13.5 6.66675 13.5Z",
    fill: "#A0AEBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 7C12.781 7 12.3333 6.55228 12.3333 6V1C12.3333 0.447715 12.781 2.41411e-08 13.3333 0C13.8856 -2.41411e-08 14.3333 0.447715 14.3333 1V6C14.3333 6.55228 13.8856 7 13.3333 7Z",
    fill: "#A0AEBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2374_21017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.b52157f4.svg";
export { ForwardRef as ReactComponent };